import jwt_decode from "jwt-decode";

export const decodeChecker = (code) => {
    try {
        return jwt_decode(code);
    } catch (err) {
        return false;
    }
}